import { graphql, useStaticQuery } from 'gatsby'

export default function GetDataHy() {
    return useStaticQuery(graphql`
        {
            text: datoCmsRenshinPageOther(title: { eq: "On top" }, locale: { eq: "hy" }) {
                value
            }
        }
    `)
}